var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2376,
    cy: 33.7063,
    r: 33.7063,
    fill: "#CD4B4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4068 31.8428C39.8819 31.8428 38.4196 32.4485 37.3414 33.5268C36.2632 34.605 35.6574 36.0673 35.6574 37.5921C35.6574 39.117 36.2632 40.5793 37.3414 41.6575C38.4196 42.7357 39.8819 43.3415 41.4068 43.3415H52.0841V51.5548H12.6602V23.6295H52.0841V31.8428H41.4068ZM43.0494 40.0561H41.4068C40.7533 40.0561 40.1265 39.7965 39.6645 39.3344C39.2024 38.8724 38.9428 38.2456 38.9428 37.5921C38.9428 36.9386 39.2024 36.3119 39.6645 35.8498C40.1265 35.3877 40.7533 35.1281 41.4068 35.1281H43.0494C43.7029 35.1281 44.3296 35.3877 44.7917 35.8498C45.2538 36.3119 45.5134 36.9386 45.5134 37.5921C45.5134 38.2456 45.2538 38.8724 44.7917 39.3344C44.3296 39.7965 43.7029 40.0561 43.0494 40.0561ZM38.9428 12.1309L45.5134 20.3442H25.8015L38.9428 12.1309Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.e4274a9c670daa2697d08b5ec1e99bbe.svg";
export { ForwardRef as ReactComponent };